import React from 'react';
import { useTranslation } from 'react-i18next';
import type { CartCalculation } from '@/services/types';
import { LoadingSkeleton, SummaryLine } from '@/components/ui';
import { formatCurrency } from '@/utils/formatters';

export interface CartTotalsProps {
    calculation: CartCalculation | null;
    loading?: boolean;
    large?: boolean;
    className?: string;
}

/** Server-calculated totals only. */
export const CartTotals: React.FC<CartTotalsProps> = ({ calculation, loading, large, className }) => {
    const { t } = useTranslation();
    if (loading && !calculation) return <LoadingSkeleton count={3} className={className} />;
    if (!calculation) return <p className={`text-sm text-ink-muted ${className ?? ''}`}>{t('cart.addItems')}</p>;
    const taxLabel = calculation.taxRate ? `${t('cart.tax')} ${calculation.taxRate}%` : t('cart.tax');
    return (
        <div className={`flex flex-col gap-[9px] ${loading ? 'opacity-60' : ''} ${className ?? ''}`}>
            <SummaryLine label={`${t('cart.subtotal')} (${t('cart.itemsCount', { count: calculation.itemCount })})`} value={formatCurrency(calculation.subtotal)} />
            {calculation.discountTotal > 0 && <SummaryLine kind="discount" label={t('cart.discount')} value={`−${formatCurrency(calculation.discountTotal)}`} />}
            <SummaryLine label={taxLabel} value={formatCurrency(calculation.taxTotal)} />
            {calculation.serviceChargeTotal > 0 && <SummaryLine label={t('cart.serviceCharge')} value={formatCurrency(calculation.serviceChargeTotal)} />}
            <SummaryLine kind="total" large={large} label={t('cart.total')} value={formatCurrency(calculation.grandTotal)} />
        </div>
    );
};
export default CartTotals;
